export const ProfileInfo = ({ children }: any) => (
  <div className="flex flex-col py-4 px-4 border border-slate-400 border-solid mb-2">
    {children}
  </div>
);
export const Hr = () => <hr className=" border border-t-solid my-3 border-gray-200" />;
